// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".image-legend p{line-height:1.3;margin:0}", "",{"version":3,"sources":["/data/mdm/deploy/mdm-front-app/releases/20210329090040/components/atoms/Editorial/ImageLegend.vue"],"names":[],"mappings":"AAkCA,gBAEI,eAAgB,CAChB,QAAS","file":"ImageLegend.vue","sourcesContent":["@import \"~@web/shared-digital-library/scss/custom\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.image-legend {\n  p {\n    line-height: 1.3;\n    margin: 0;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
